export const INFINITE_SCROLL_DIRECTIONS = {
  UP: "up",
  DOWN: "down",
};
